// shared helper for apps that need to define a common i18n context
import { createContext } from '../context/context-key.js';
export const i18nConfigContext = createContext('i18nConfig');
//# sourceMappingURL=context.js.map